import OapPromoBar from './code/Scripts/components/oap-promo-bar.vue';

export default {
  components: {
    OapPromoBar,
  },
};
